module.exports = __webpack_public_path__ + "37ba24d88be4c9668976710e6fbb2cac.svg";